module.exports = __webpack_public_path__ + "img/907b712.png";